<template>
    <div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">

                <navbar1 />

                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">

                        <navbar2 />

                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body">
                                    <div class="page-wrapper">
                                        <div class="page-body">
                                            <div class="row">
                                                <div class="col-md-3">
                                                    <div class="card bg-c-blue text-white widget-visitor-card">
                                                        <div class="card-block-small text-center">
                                                            <h2>{{applicants.length}}</h2>
                                                            <h6>In Process</h6>
                                                            <br>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-md-3">
                                                    <div class="card bg-c-pink text-white widget-visitor-card">
                                                        <div class="card-block-small text-center">
                                                            <h2>{{stage_1.length}}</h2>
                                                            <h6>Pending Hiring Approval</h6>
                                                            <br>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-md-3">
                                                    <div class="card bg-c-green text-white widget-visitor-card">
                                                        <div class="card-block-small text-center">
                                                            <h2>{{stage_2.length}}</h2>
                                                            <h6>Pending Offer Letter</h6>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-md-3">
                                                    <div class="card bg-c-yellow text-white widget-visitor-card">
                                                        <div class="card-block-small text-center">
                                                            <h2>{{stage_3.length}}</h2>
                                                            <h6>Pending Offer Letter Approval</h6>
                                                            <br>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-md-3">
                                                    <div class="card bg-c-orenge text-white widget-visitor-card">
                                                        <div class="card-block-small text-center">
                                                            <h2>{{stage_4.length}}</h2>
                                                            <h6>Offer Letter Approved</h6>
                                                            <br>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-md-3">
                                                    <div class="card bg-c-lite-green text-white widget-visitor-card">
                                                        <div class="card-block-small text-center">
                                                            <h2>{{stage_5.length}}</h2>
                                                            <h6>Pending Applicant Response</h6>
                                                            <br>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-md-3">
                                                    <div class="card bg-c-orenge text-white widget-visitor-card">
                                                        <div class="card-block-small text-center">
                                                            <h2>{{stage_6.length}}</h2>
                                                            <h6>Pending Recruitment</h6>
                                                            <br>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-md-3">
                                                    <div class="card bg-c-blue text-white widget-visitor-card">
                                                        <div class="card-block-small text-center">
                                                            <h2>{{stage_7.length}}</h2>
                                                            <h6>Recruited</h6>
                                                            <br>
                                                        </div>
                                                    </div>
                                                </div>

                                                <!-- Marketing Start -->
                                                <div v-if="$checkPerm('application.approve_hiring')" class="col-lg-6 col-md-12">
                                                    <div class="card">
                                                        <div class="card-header">
                                                            <div class="card-header-left">
                                                                <h5>Action: Approve for Hiring</h5>
                                                            </div>
                                                            <div class="card-header-right">

                                                            </div>
                                                        </div>
                                                        <div class="card-block marketing-card p-t-0">
                                                            <div class="table-responsive">
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Name</th>
                                                                            <th>Email</th>
                                                                            <th>Role</th>
                                                                            <th>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody v-if="stage_1.length > 0">
                                                                        <tr v-for="applicant in stage_1">
                                                                            <td>{{applicant.firstname + " " +
                                                                                applicant.lastname}}</td>
                                                                            <td>{{applicant.emailaddress}}</td>
                                                                            <td>{{applicant.joblistings.jobrole.name}}</td>
                                                                            <td>
                                                                                <a target="_blank" class="btn btn-primary btn-sm btn-mat"
                                                                                    v-bind:href="'/usersummary/' + applicant.id">Respond</a>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                    <span class="label label-info" v-else>No applicants
                                                                        in this category</span>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- Marketing End -->

                                                <!-- Marketing Start -->
                                                <div v-if="$checkPerm('application.forward_offer_to_approver')" class="col-lg-6 col-md-12">
                                                    <div class="card">
                                                        <div class="card-header">
                                                            <div class="card-header-left">
                                                                <h5>Action: Update offer letter and foward for approval</h5>
                                                            </div>
                                                            <div class="card-header-right">

                                                            </div>
                                                        </div>
                                                        <div class="card-block marketing-card p-t-0">
                                                            <div class="table-responsive">
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Name</th>
                                                                            <th>Email</th>
                                                                            <th>Role</th>
                                                                            <th>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody v-if="stage_2.length > 0">
                                                                        <tr v-for="applicant in stage_2">
                                                                            <td>{{applicant.firstname + " " +
                                                                                applicant.lastname}}</td>
                                                                            <td>{{applicant.emailaddress}}</td>
                                                                            <td>{{applicant.joblistings.jobrole.name}}</td>
                                                                            <td>
                                                                                <a target="_blank" class="btn btn-primary btn-sm btn-mat"
                                                                                    v-bind:href="'/usersummary/' + applicant.id">Respond</a>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                    <span class="label label-info" v-else>No applicants
                                                                        in this category</span>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- Marketing End -->

                                                <!-- Marketing Start -->
                                                <div v-if="$checkPerm('application.approve_offer')" class="col-lg-6 col-md-12">
                                                    <div class="card">
                                                        <div class="card-header">
                                                            <div class="card-header-left">
                                                                <h5>Action: Approve offer letter</h5>
                                                            </div>
                                                            <div class="card-header-right">

                                                            </div>
                                                        </div>
                                                        <div class="card-block marketing-card p-t-0">
                                                            <div class="table-responsive">
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Name</th>
                                                                            <th>Email</th>
                                                                            <th>Role</th>
                                                                            <th>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody v-if="stage_3.length > 0">
                                                                        <tr v-for="applicant in stage_3">
                                                                            <td>{{applicant.firstname + " " +
                                                                                applicant.lastname}}</td>
                                                                            <td>{{applicant.emailaddress}}</td>
                                                                            <td>{{applicant.joblistings.jobrole.name}}</td>
                                                                            <td>
                                                                                <a target="_blank" class="btn btn-primary btn-sm btn-mat"
                                                                                    v-bind:href="'/usersummary/' + applicant.id">Respond</a>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                    <span class="label label-info" v-else>No applicants
                                                                        in this category</span>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- Marketing End -->

                                                <!-- Marketing Start -->
                                                <div v-if="$checkPerm('application.forward_offer_to_candidate')" class="col-lg-6 col-md-12">
                                                    <div class="card">
                                                        <div class="card-header">
                                                            <div class="card-header-left">
                                                                <h5>Action: Send offer to candidate</h5>
                                                            </div>
                                                            <div class="card-header-right">

                                                            </div>
                                                        </div>
                                                        <div class="card-block marketing-card p-t-0">
                                                            <div class="table-responsive">
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Name</th>
                                                                            <th>Email</th>
                                                                            <th>Role</th>
                                                                            <th>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody v-if="stage_4.length > 0">
                                                                        <tr v-for="applicant in stage_4">
                                                                            <td>{{applicant.firstname + " " +
                                                                                applicant.lastname}}</td>
                                                                            <td>{{applicant.emailaddress}}</td>
                                                                            <td>{{applicant.joblistings.jobrole.name}}</td>
                                                                            <td>
                                                                                <a target="_blank" class="btn btn-primary btn-sm btn-mat"
                                                                                    v-bind:href="'/usersummary/' + applicant.id">Respond</a>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                    <span class="label label-info" v-else>No applicants
                                                                        in this category</span>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- Marketing End -->

                                                <!-- Marketing Start -->
                                                <div v-if="$checkPerm('application.approve_offer')" class="col-lg-6 col-md-12">
                                                    <div class="card">
                                                        <div class="card-header">
                                                            <div class="card-header-left">
                                                                <h5>Pending candidate response</h5>
                                                            </div>
                                                            <div class="card-header-right">

                                                            </div>
                                                        </div>
                                                        <div class="card-block marketing-card p-t-0">
                                                            <div class="table-responsive">
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Name</th>
                                                                            <th>Email</th>
                                                                            <th>Role</th>
                                                                            <th>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody v-if="stage_5.length > 0">
                                                                        <tr v-for="applicant in stage_5">
                                                                            <td>{{applicant.firstname + " " +
                                                                                applicant.lastname}}</td>
                                                                            <td>{{applicant.emailaddress}}</td>
                                                                            <td>{{applicant.joblistings.jobrole.name}}</td>
                                                                            <td>
                                                                                <a target="_blank" class="btn btn-primary btn-sm btn-mat"
                                                                                    v-bind:href="'/usersummary/' + applicant.id">Respond</a>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                    <span class="label label-info" v-else>No applicants
                                                                        in this category</span>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- Marketing End -->

                                                <!-- Marketing Start -->
                                                <div v-if="$checkPerm('application.recruit_hr_live')" class="col-lg-6 col-md-12">
                                                    <div class="card">
                                                        <div class="card-header">
                                                            <div class="card-header-left">
                                                                <h5>Action: Recruit to HR Live</h5>
                                                            </div>
                                                            <div class="card-header-right">

                                                            </div>
                                                        </div>
                                                        <div class="card-block marketing-card p-t-0">
                                                            <div class="table-responsive">
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th>Name</th>
                                                                            <th>Email</th>
                                                                            <th>Role</th>
                                                                            <th>Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody v-if="stage_6.length > 0">
                                                                        <tr v-for="applicant in stage_6">
                                                                            <td>{{applicant.firstname + " " +
                                                                                applicant.lastname}}</td>
                                                                            <td>{{applicant.emailaddress}}</td>
                                                                            <td>{{applicant.joblistings.jobrole.name}}</td>
                                                                            <td>
                                                                                <a target="_blank" class="btn btn-primary btn-sm btn-mat"
                                                                                    v-bind:href="'/usersummary/' + applicant.id">Respond</a>
                                                                            </td>
                                                                        </tr>
                                                                    </tbody>
                                                                    <span class="label label-info" v-else>No applicants
                                                                        in this category</span>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- Marketing End -->
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import navbar1 from '../components/Navbar1.vue'
    import navbar2 from '../components/Navbar2.vue'

    export default {
        name: 'RecruitmentDashboard',

        data() {
            return {
                applicants: [],
                stage_1: [],
                stage_2: [],
                stage_3: [],
                stage_4: [],
                stage_5: [],
                stage_6: [],
                stage_7: []
            }
        },

        components: {
            navbar1,
            navbar2
        },

        mounted() {
            this.init()
        },
        methods: {

            init: function () {
                this.getProcessing()
            },

            getProcessing: function () {

                let get_obj = {
                    what: 'ProcessingApplicants'
                }

                this.$socket.makeGetRequest(get_obj)
                    .then((response) => {
                        if (response.type == "ProcessingApplicants") {
                            this.applicants = response.data

                            var a_length = response.data.length

                            for (var i = 0; i < a_length; i++) {
                                var stage = "stage_" + response.data[i].applicant_final_stage.id
                                this[stage].push(response.data[i])
                            }
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },

            postRequest: function () {

                let post_obj = {
                    what: 'PostWhat',
                    data: {}
                }

                this.$socket.makeGetRequest(post_obj)
                    .then((response) => {
                        if (response.type == "PostWhat") {
                            console.log(response.data)
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }

        },
        computed: {

        }
    }
</script>